import React, { useEffect } from 'react';
import TopNavigation from '../components/TopNavigation';

const Terms: React.FC = () => {
  useEffect(() => {
    const id = window.location.hash.slice(1);
    if (id) setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' }), 50);
  }, []);
  return (
    <div style={styles.container}>
      <TopNavigation />
      <div style={styles.contentArea}>
        <header style={styles.header}>
          <h1 style={styles.title}>Terms of Service</h1>
          <p style={styles.subtitle}>Effective date: October 26, 2025</p>
        </header>

        <section style={styles.section}>
          <h2 style={styles.h2}>1. Acceptance of Terms</h2>
          <p style={styles.p}>
            By creating an account, accessing, or using Belivah (the "Service"), you agree to these Terms of Service and our
            Privacy Policy. If you do not agree, do not use the Service.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.h2}>2. Eligibility and Accounts</h2>
          <p style={styles.p}>
            You must be at least 13 years old (or the minimum age in your jurisdiction) to use Belivah. You are responsible
            for maintaining the confidentiality of your account and for all activities that occur under your account.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.h2}>3. Your Content and Conduct</h2>
          <ul style={styles.ul}>
            <li>You own the content you post. By posting, you grant Belivah a non-exclusive, worldwide, royalty-free license to host, store, reproduce, distribute, and display your content for the purpose of operating and improving the Service.</li>
            <li>You represent that you have all rights necessary to post your content and that your content does not infringe or violate any third-party rights or laws.</li>
            <li>You agree not to post unlawful, harmful, hateful, harassing, defamatory, obscene, sexually explicit, or otherwise inappropriate content, and not to encourage violence or illegal activity.</li>
            <li>We may remove or restrict content, and suspend or terminate accounts, at our discretion, including to comply with law or protect our community.</li>
          </ul>
        </section>

        <section style={styles.section}>
          <h2 style={styles.h2}>4. Prohibited Activities</h2>
          <ul style={styles.ul}>
            <li>No spamming, scams, or deceptive practices.</li>
            <li>No harassment, bullying, threats, or incitement of violence.</li>
            <li>No uploading malware, scraping, or attempting to gain unauthorized access.</li>
            <li>No infringement of intellectual property or privacy rights.</li>
          </ul>
        </section>

        <section style={styles.section}>
          <h2 style={styles.h2}>5. Intellectual Property</h2>
          <p style={styles.p}>
            Belivah, including the logo, trademarks, and software, is owned by Belivah and its licensors. Except for the limited
            license to use the Service, no rights are granted. Do not copy, modify, or create derivative works from Belivah’s
            services without permission.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.h2}>6. Copyright and DMCA</h2>
          <p style={styles.p}>
            If you believe content infringes your copyright, send a notice to dmca@belivah.com with: (a) your contact details,
            (b) identification of the copyrighted work and the alleged infringing material, (c) a statement of good-faith belief,
            and (d) a statement under penalty of perjury that the notice is accurate and you are authorized to act. We may
            remove content and, where appropriate, terminate repeat infringers.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.h2}>7. Privacy</h2>
          <p style={styles.p}>
            Our collection and use of personal information is described in our Privacy Policy. By using the Service, you consent
            to these practices.
          </p>
        </section>

        <section id="monetization" style={styles.section}>
          <h2 style={styles.h2}>8. Creator Monetization</h2>
          <p style={styles.p}>
            Eligible creators, including music creators whose music is used in videos, may share in advertising revenue earned
            on their content. To qualify, an account must be more than 60 days old, have at least 5,000 followers and have at least
            60,000 watch hours on its videos and Pulse, and must be in good standing with these Terms and our Community Guidelines.
            Monetization is enabled automatically once the requirements are met.
          </p>
          <p style={styles.p}>
            Only genuine engagement from real viewers counts towards earnings. Belivah determines eligible views, ad engagement and
            revenue share at its sole discretion and may adjust these rules at any time. Artificial, self-generated, incentivised,
            automated or otherwise invalid activity is not paid and may lead to withheld earnings, loss of monetization or account
            termination.
          </p>
          <p style={styles.p}>
            Earnings are held for a review period before becoming available and are paid to the creator's PayPal account once the
            minimum withdrawal amount is reached. Belivah may withhold or reverse earnings linked to invalid activity, chargebacks or
            violations of these Terms.
          </p>
        </section>
        <section style={styles.section}>
          <h2 style={styles.h2}>9. Third-Party Links and Services</h2>
          <p style={styles.p}>
            Belivah may contain links to third-party sites or services. We are not responsible for their content, policies,
            or practices. Your use of third-party services is at your own risk.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.h2}>10. Disclaimers</h2>
          <p style={styles.p}>
            THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, WHETHER EXPRESS OR IMPLIED,
            INCLUDING BUT NOT LIMITED TO WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.
            WE DO NOT WARRANT THAT THE SERVICE WILL BE UNINTERRUPTED, SECURE, OR ERROR-FREE.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.h2}>11. Limitation of Liability</h2>
          <p style={styles.p}>
            TO THE MAXIMUM EXTENT PERMITTED BY LAW, BELIVAH AND ITS OWNERS, DIRECTORS, EMPLOYEES, PARTNERS, AND AFFILIATES
            SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, PUNITIVE, OR EXEMPLARY DAMAGES, OR ANY
            LOSS OF DATA, PROFITS, REVENUE, OR BUSINESS, ARISING OUT OF OR RELATED TO YOUR USE OF THE SERVICE, EVEN IF ADVISED
            OF THE POSSIBILITY OF SUCH DAMAGES.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.h2}>12. Indemnification</h2>
          <p style={styles.p}>
            You agree to defend, indemnify, and hold harmless Belivah and its owners, directors, employees, and affiliates from
            and against any claims, liabilities, damages, losses, and expenses (including reasonable attorney fees) arising out of
            or related to: (a) your use of the Service; (b) your content; or (c) your violation of these Terms or applicable law.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.h2}>13. Governing Law and Dispute Resolution</h2>
          <p style={styles.p}>
            These Terms are governed by the laws of your principal place of business (without regard to conflict-of-law rules).
            Any disputes shall be resolved through binding arbitration on an individual basis, and you waive any right to
            participate in a class action. You and Belivah agree to seek amicable resolution before formal proceedings.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.h2}>14. Changes to the Service and Terms</h2>
          <p style={styles.p}>
            We may modify or discontinue features at any time. We may update these Terms from time to time. If we make material
            changes, we will provide notice (such as by email or in-app). Your continued use of the Service after changes
            constitutes acceptance.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.h2}>15. Termination</h2>
          <p style={styles.p}>
            We may suspend or terminate your access to the Service at any time for any reason, including violation of these
            Terms or applicable law. You may stop using the Service at any time.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.h2}>16. Contact</h2>
          <p style={styles.p}>For questions about these Terms, contact legal@belivah.com</p>
        </section>

        <section style={styles.section}>
          <p style={{...styles.p, fontSize: 12, color: '#5B6E6E'}}>
            Nothing in these Terms is intended to limit any non-waivable rights under applicable law. This document is provided for
            general informational purposes only and does not constitute legal advice.
          </p>
        </section>
      </div>
    </div>
  );
};

const styles: { [k: string]: React.CSSProperties } = {
  container: { display: 'flex', flexDirection: 'column', minHeight: '100vh', background: 'var(--color-background-alt)' },
  contentArea: { paddingTop: '80px', maxWidth: '900px', margin: '0 auto', padding: '20px' },
  header: { background: '#0B6B6F', color: '#fff', padding: '20px 24px', borderRadius: 12 },
  title: { margin: 0, fontSize: 28 },
  subtitle: { margin: '6px 0 0 0', fontSize: 14 },
  section: { background: '#fff', borderRadius: 12, padding: 20, marginTop: 16, border: '1px solid var(--color-border)' },
  h2: { margin: '0 0 10px 0', color: '#072B2C', fontSize: 20 },
  p: { margin: 0, color: '#072B2C' },
  ul: { margin: '0 0 0 18px', color: '#072B2C' },
};

export default Terms;
